import enums from "./../enums";

const bonus = (
	state = {
		userAvailableBonuses: [],
		userAvailableBonusesLoading: false,
		userAvailableBonusesError: null,
		userAvailableBonusesOffset: undefined,
		activeBonusPresentList: [],
		activeBonusPresenLoading: false,
		bonusContent: {},
		clickBonusWheel: [],
		presentIconVisible: false,
		bonusHistory: {
			reports: [],
		},
		bonus: {
			list: [],
		},
		filteredBonuses: [],
		visibleBonus: {
			list: [],
		},
		bonusLoading: false,
	},
	{ type, payload }
) => {
	try {
		switch (type) {
			case enums.PRESENT_BOX_VISIBILITY: {
				return { ...state, presentIconVisible: payload };
			}
			case enums.APP_BONUS_LIST: {
				let bonus = { ...state.bonus },
					filteredList = payload.bonusList.filter((i) => !!i.isVisibleToEndUser);
				if (payload.isUpdate) {
					bonus = {
						...bonus,
						list: [...bonus.list, ...filteredList],
						offset: payload.offset,
					};
				} else {
					bonus = { ...payload, list: filteredList };
				}
				return { ...state, bonus };
			}
			case enums.APP_VISIBLE_BONUS_LIST: {
				let visibleBonus = { ...state.visibleBonus },
					filteredList = payload.bonusList;
				if (payload.isUpdate) {
					visibleBonus = {
						...visibleBonus,
						list: [...visibleBonus.list, ...filteredList],
						offset: payload.offset,
					};
				} else {
					visibleBonus = { ...payload, list: filteredList };
				}
				return { ...state, visibleBonus };
			}
			case enums.APP_FILTERED_BONUS_LIST: {
				return { ...state, filteredBonuses: payload };
			}
			case enums.APP_BONUS_LOADING:
				return { ...state, bonusLoading: payload };

			case enums.GET_USER_AVAILABLE_BONUSES_SUCCESS: {
				return {
					...state,
					userAvailableBonuses: [...payload.bonusClaims],
					userAvailableBonusesOffset: payload.offset || null,
				};
			}
			case enums.UPDATE_USER_AVAILABLE_BONUSES_SUCCESS: {
				return {
					...state,
					userAvailableBonuses: [...state.userAvailableBonuses, ...payload.bonusClaims],
					userAvailableBonusesOffset: payload.offset || null,
				};
			}
			case enums.LIST_BONUS_HISTORY: {
				let data = { ...payload };
				data.reports = data.reports.map((i) => ({
					...i,
					walletContributions: i.walletContributions.map((x) => {
						let walletId = x.walletId;
						if (data.wagering && data.wagering[walletId]) {
							return { ...x, ...data.wagering[walletId] };
						}
						return x;
					}),
				}));
				return {
					...state,
					bonusHistory: {
						...data,
						offset: payload.lastItem || null,
					},
				};
			}
			case enums.UPDATE_LIST_BONUS_HISTORY: {
				const { reports } = payload;
				const modifiedReports = reports.map((i) => ({
					...i,
					walletContributions: i.walletContributions.map((x) => {
						let walletId = x.walletId;
						if (payload.wagering && payload.wagering[walletId]) {
							return { ...x, ...payload.wagering[walletId] };
						}
						return x;
					}),
				}));
				debugger;
				return {
					...state,
					bonusHistory: {
						reports: [...state.bonusHistory.reports, ...modifiedReports],
						offset: payload.lastItem || null,
					},
				};
			}
			case enums.CLEAR_USER_AVAILABLE_BONUSES: {
				return {
					...state,
					userAvailableBonuses: [],
					userAvailableBonusesLoading: false,
					userAvailableBonusesError: null,
					userAvailableBonusesOffset: undefined,
				};
			}
			case enums.GET_USER_AVAILABLE_BONUSES_LOADING: {
				return { ...state, userAvailableBonusesLoading: payload };
			}
			case enums.GET_USER_AVAILABLE_BONUSES_ERROR: {
				return { ...state, userAvailableBonusesError: payload };
			}
			case enums.GET_ACTIVE_BONUS_PRESENT_LOADING: {
				return { ...state, activeBonusPresenLoading: payload };
			}
			case enums.GET_ACTIVE_BONUS_PRESENT_LIST: {
				return { ...state, activeBonusPresentList: payload };
			}
			case enums.GET_ACTIVE_BONUS_CONTENT: {
				return { ...state, bonusContent: payload };
			}
			case enums.GET_ACTIVE_BONUS_CLICK_TIME: {
				return { ...state, clickBonusWheel: payload };
			}
			default:
				return { ...state };
		}
	} catch (err) {
		console.error("[ERR: BONUX REDUCER] ", err.message);
		return { ...state };
	}
};

export default bonus;
